import { render, staticRenderFns } from "./BaiduConversationDialog.vue?vue&type=template&id=20dc7109"
import script from "./BaiduConversationDialog.vue?vue&type=script&lang=js"
export * from "./BaiduConversationDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports